<!-- MENU DESKTOP -->
<header id="header-cercacasa"
  class="main-header {{isPrimary ? '' : 'main-header--secondary'}} {{shadow ? '' : 'noShadow'}}">
  @if (this.isPrimary) {
  <div class="top-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="top-header-inner">
            <p>Trova i migliori professionisti dell’immobiliare e la casa ideale.</p>
            <ul class="social-media">
              <li>
                <a [routerLink]="['chi-siamo']" class="p-0 m-0">
                  <i class="icon-question-circle" title="Chi siamo"></i>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/cercacasa.it" rel="noreferrer" target="_blank" class="p-0 m-0 ps-3">
                  <i class="icon-facebook-brands" title="Pagina Facebook"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <nav class="navbar">
    <div class="container">
      <a class="navbar-brand" [routerLink]="['/']">
        <img id="logoWhiteHeader" ngSrc="assets/img/logocercacasa.png" width="110" height="18" alt="logo">
        <img id="logoBlueHeader" ngSrc="assets/img/logoblu.png" width="110" height="18" alt="logo">
      </a>
      <ul class="navbar-nav">
        <li (click)="clickSearchType('agente')" class="menu-item menu-item-has-children cursor-pointer">
          <p class="agente">{{ this.showProfessionist ? 'Professionisti' : 'Agente' }}</p>
        </li>
        <li (click)="clickSearchType('vendita')" class="menu-item menu-item-has-children cursor-pointer">
          <p>Vendita</p>
        </li>
        <li (click)="clickSearchType('affitto')" class="menu-item menu-item-has-children cursor-pointer">
          <p>Affitto</p>
        </li>
        @if (this.showNews) {
        <li [routerLink]="['/news']" target="_blank" class="menu-item menu-item-has-children cursor-pointer">
          <p>News</p>
        </li>
        }
      </ul>
      @defer {
      <div class="header-controls">
        <div class="header-controls-inner d-none d-lg-flex">
          @if (this.isLogged) {
          <div (mouseenter)="this.isHoverMenu=true" (mouseleave)="this.isHoverMenu=false"
            class="imageAndNameCont d-flex align-items-center cursor-pointer">
            <div *ngIf="this.isLogged && !this.currentUser?.profile_img" [routerLink]="['/utente']"
              class="circleBackground cursor-pointer">
              {{ this.currentUser?.first_name?.charAt(0)?.toUpperCase() }}{{
              this.currentUser?.last_name?.charAt(0)?.toUpperCase() }}
            </div>
            <div *ngIf="this.isLogged && this.currentUser?.profile_img" [routerLink]="['/utente']"
              class="circleBackground circleBackground--transparent cursor-pointer">
              <img ngSrc="{{currentUser?.profile_img}}" width="40" height="40" alt="Immagine profilo utente">
            </div>
            <div class="linkTo ms-3">
              <p class="cursor-pointer d-inline-block m-0" [class.colorPrimary]="this.isHoverMenu"
                [routerLink]="['/utente']">{{ this.currentUser?.first_name }}
                {{ this.currentUser?.last_name }}</p>
            </div>
            <div (mouseenter)="this.isHoverMenu=true" (mouseleave)="this.isHoverMenu=false"
              [class.smallDesktopMenu--show]="isHoverMenu" class="smallDesktopMenu">
              <hr>
              <div class="ms-0 smallDesktopMenu__item" [routerLink]="['/utente']"><a
                  href="javascript:void(0);">Profilo</a></div>
              <div class="ms-0 smallDesktopMenu__item" [routerLink]="['/utente-annunci']"><a
                  href="javascript:void(0);">Annunci</a></div>
              <div class="ms-0 smallDesktopMenu__item" [routerLink]="['/utente-agenzie']"><a
                  href="javascript:void(0);">Agenzie</a></div>
              <div class="ms-0 smallDesktopMenu__item" [routerLink]="['/utente-agenti']"><a
                  href="javascript:void(0);">Agenti immobiliari</a></div>
              <div *ngIf="this.showProfessionist" class="ms-0 smallDesktopMenu__item"
                [routerLink]="['/utente-professionisti']"><a href="javascript:void(0);">Consulenti
                  del credito</a></div>
              <div class="ms-0 smallDesktopMenu__item" [routerLink]="['/utente-ricerche']"><a
                  href="javascript:void(0);">Ricerche</a></div>
              <div class="ms-0 smallDesktopMenu__item"><a href="javascript:void(0);"
                  (click)="this.main?.logout()">Logout</a></div>
            </div>
          </div>
          } @else {
          <div (click)="this.openPopup()" class="d-flex align-items-center cursor-pointer">
            <i class="icon-user-circle me-2"></i>
            <p class="d-inline-block m-0 hover-underline d-none d-md-block d-lg-block ">Accedi o registrati
            </p>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </nav>
</header>

<app-popup *ngIf="this.modalIsOpen" (closePopupEvent)="this.closePopup()" [modalIsOpen]="this.modalIsOpen"
  [reviewFormIsValid]="true" [isReviewPage]="false" [formValue]="this.formValue">
</app-popup>